var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconBlogRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 64 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M61.747 24.508H3.015M37.102 46.026l24.65-21.513L37.102 3",
  stroke: "currentColor",
  strokeWidth: 4.303,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export default SvgIconBlogRight;